/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions";
import { CALL_API } from "../middleware"
import {
    ADD_TO_CART,
    ADD_TO_CART_SUCCESS,
    AddToCartRequestBody,
    AddToCartResponseBody,
    DELETE_CART_ITEM,
    DELETE_CART_ITEM_SUCCESS,
    DeleteCartItemRequestBody,
    DeleteCartItemResponseBody,
    EDIT_CART_ITEM,
    EDIT_CART_ITEM_SUCCESS,
    EditCartItemRequestBody,
    EditCartItemResponseBody,
    GENERATE_OTP,
    GENERATE_OTP_SUCCESS,
    GenerateOtpRequestBody,
    GenerateOtpResponseBody,
    GET_CART_ITEMS,
    GET_CART_ITEMS_COUNT,
    GET_CART_ITEMS_COUNT_SUCCESS,
    GET_CART_ITEMS_SUCCESS,
    GET_ORDER_PREVIEW,
    GET_ORDER_PREVIEW_SUCCESS,
    GetCartItemsCountRequestBody,
    GetCartItemsCountResponseBody,
    GetCartItemsRequestBody,
    GetCartItemsResponseBody,
    GetOrderPreviewResponseBody,
    INITIATE_PAYMENT,
    INITIATE_PAYMENT_SUCCESS,
    InitiatePaymentRequestBody,
    InitiatePaymentResponseBody,
    ORDER_PREVIEW_OPEN_FLOW,
    ORDER_PREVIEW_OPEN_FLOW_SUCCESS,
    OrderPreviewOpenFlowRes,
    PAYMENT_OPEN_FLOW_GEN_OTP,
    PAYMENT_OPEN_FLOW_GEN_OTP_SUCCESS,
    PAYMENT_OPEN_FLOW_RESEND_OTP,
    PAYMENT_OPEN_FLOW_RESEND_OTP_SUCCESS,
    PAYMENT_OPEN_FLOW_VALIDATE_OTP,
    PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS,
    PLACE_ORDER,
    PLACE_ORDER_SUCCESS,
    PlaceOrderRequestBody,
    PlaceOrderResponseBody,
    RESEND_OTP,
    RESEND_OTP_SUCCESS,
    ResendOtpRequestBody,
    ResendOtpResponseBody,
    SET_CART_ITEMS_COUNT,
    VALIDATE_OTP,
    VALIDATE_OTP_SUCCESS,
    ValidateOtpRequestBody,
    ValidateOtpResponseBody
} from "../types/cart";


export const getCartItems =
    (body: GetCartItemsRequestBody) =>
        async (dispatch: any): Promise<GetCartItemsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/viewCart',
                    method: 'POST',
                    types: [GET_CART_ITEMS_SUCCESS, GET_CART_ITEMS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const addToCart =
    (body: AddToCartRequestBody) =>
        async (dispatch: any): Promise<AddToCartResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/addToCart',
                    method: 'POST',
                    types: [ADD_TO_CART_SUCCESS, ADD_TO_CART],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const deleteCartItem =
    (body: DeleteCartItemRequestBody) =>
        async (dispatch: any): Promise<DeleteCartItemResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/deleteCart',
                    method: 'POST',
                    types: [DELETE_CART_ITEM_SUCCESS, DELETE_CART_ITEM],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getCartItemsCount =
    (body: GetCartItemsCountRequestBody) =>
        async (dispatch: any): Promise<GetCartItemsCountResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/cartItemsCount',
                    method: 'POST',
                    types: [GET_CART_ITEMS_COUNT_SUCCESS, GET_CART_ITEMS_COUNT],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const setCartItemsCount =
    (cartItemsCount: number): { type: string; cartItemsCount: number } => {
        return {
            type: SET_CART_ITEMS_COUNT,
            cartItemsCount,
        };
    };

export const editCartItem =
    (body: EditCartItemRequestBody) =>
        async (dispatch: any): Promise<EditCartItemResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/editCart',
                    method: 'POST',
                    types: [EDIT_CART_ITEM_SUCCESS, EDIT_CART_ITEM],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const placeOrder =
    (body: PlaceOrderRequestBody) =>
        async (dispatch: any): Promise<PlaceOrderResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/placeOrder',
                    method: 'POST',
                    types: [PLACE_ORDER_SUCCESS, PLACE_ORDER],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const generateOtp =
    (body: GenerateOtpRequestBody) =>
        async (dispatch: any): Promise<GenerateOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/generate-otp',
                    method: 'POST',
                    types: [GENERATE_OTP_SUCCESS, GENERATE_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const paymentOpenFlowGenOtp =
    (body: GenerateOtpRequestBody) =>
        async (dispatch: any): Promise<GenerateOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/payment-open-flow/generate-otp',
                    method: 'POST',
                    types: [PAYMENT_OPEN_FLOW_GEN_OTP_SUCCESS, PAYMENT_OPEN_FLOW_GEN_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
export const validateOtp =
    (body: ValidateOtpRequestBody) =>
        async (dispatch: any): Promise<ValidateOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/validate-otp',
                    method: 'POST',
                    types: [VALIDATE_OTP_SUCCESS, VALIDATE_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const paymentOpenFlowValOtp =
    (body: ValidateOtpRequestBody) =>
        async (dispatch: any): Promise<ValidateOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/payment-open-flow/validate-otp',
                    method: 'POST',
                    types: [PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS, PAYMENT_OPEN_FLOW_VALIDATE_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const resendOtp =
    (body: ResendOtpRequestBody) =>
        async (dispatch: any): Promise<ResendOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/resend-otp',
                    method: 'POST',
                    types: [RESEND_OTP_SUCCESS, RESEND_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const paymentOpenFlowResendOtp =
    (body: ResendOtpRequestBody) =>
        async (dispatch: any): Promise<ResendOtpResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/payment-open-flow/resend-otp',
                    method: 'POST',
                    types: [PAYMENT_OPEN_FLOW_RESEND_OTP_SUCCESS, PAYMENT_OPEN_FLOW_RESEND_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getOrderPreview =
    (token: string) =>
        async (dispatch: any): Promise<GetOrderPreviewResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/order-preview/${token}`,
                    method: 'GET',
                    types: [GET_ORDER_PREVIEW_SUCCESS, GET_ORDER_PREVIEW],
                },
            });
        };

export const orderPreviewOpenFlow =
    (paymentId: string) =>
        async (dispatch: any): Promise<OrderPreviewOpenFlowRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/payment-open-flow/order-preview/${paymentId}`,
                    method: 'GET',
                    types: [ORDER_PREVIEW_OPEN_FLOW_SUCCESS, ORDER_PREVIEW_OPEN_FLOW],
                    token: ""
                },
            });
        };

export const initiatePayment =
    (body: InitiatePaymentRequestBody) =>
        async (dispatch: any): Promise<InitiatePaymentResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/initiate-payment',
                    method: 'POST',
                    types: [INITIATE_PAYMENT_SUCCESS, INITIATE_PAYMENT],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
